import React from 'react'
import { PrismicLink, PrismicRichText } from '@prismicio/react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

import BookingForm from './bookingForm'

const PageHeader = ({ type, pageData, uid }) => {
  let images = pageData.page_image?.gatsbyImageData
  if (pageData.page_image?.thumbnails.mobile.gatsbyImageData) {
    images = withArtDirection(getImage(pageData.page_image.gatsbyImageData), [
      {
        media: '(max-width: 768px)',
        image: getImage(pageData.page_image.thumbnails.mobile.gatsbyImageData)
      }
    ])
  }

  const event = type === 'event' || type === 'room'
  return (
    <div className={`relative ${uid === 'index' || uid === 'rooms' ? 'mb-10' : ''}`}>
      <div className={`relative grid grid-cols-1 grid-rows-1 overflow-hidden text-white bg-cyan-950`}>
        {images && (
          <div className='absolute inset-0'>
            <GatsbyImage className='absolute inset-0 h-full bg-cover' layout='fullWidth' loading='eager' image={images} alt={pageData.page_image.alt || ''} />
            <div className='absolute inset-0 bg-stone-950 bg-opacity-30' />
            <div className='absolute inset-x-0 bottom-0 h-16 from from-stone-50 via-stone-50/50 via-25% bg-gradient-to-t z-10' />
          </div>
        )}
        <div
          className={`hero relative col-span-full row-span-full mx-auto flex flex-col font-semibold items-center gap-6 p-10 pt-40 md:pt-60 text-center md:max-w-screen-lg text-xl lg:text-3xl ${uid === 'rooms' && 'md:pb-32'} ${images && 'md:pb-52 lg:pb-64 drop-shadow'}`}>
          <div className='text-lg bg-white px-3 rounded-full text-cyan-700'>{pageData.date_fromnow_formatted}</div>
          <PrismicRichText field={pageData.page_title.richText} />
          {event ? (
            <>
              {(pageData.start_date_and_time || pageData.start_date_and_time) && (
                <div className='flex flex-col gap-2'>
                  <div>{pageData.start_date_formatted === pageData.end_date_formatted ? pageData.start_date_formatted : `${pageData.start_date_formatted} to ${pageData.end_date_formatted}`}</div>
                  <div className='text-lg font-semibold'>
                    {pageData.start_time_formatted && pageData.start_time_formatted} {pageData.end_time_formatted && pageData.end_time_formatted}
                  </div>
                </div>
              )}
              {pageData.size && <div className='text-lg bg-white px-3 rounded-full text-cyan-700'>{pageData.size}</div>}
              {pageData.introduction && <div>{pageData.introduction}</div>}
            </>
          ) : (
            <>
              {pageData.page_text.text && <PrismicRichText field={pageData.page_text.richText} />}
              <PrismicLink className='button' field={pageData.page_button_link}>
                {pageData.page_button_text}
              </PrismicLink>
            </>
          )}
        </div>
      </div>
      {(uid === 'index' || uid === 'rooms') && (
        <div className='fixed bottom-0 md:absolute md:inset-x-0 md:-bottom-10 w-full max-w-screen-xl mx-auto z-20'>
          <BookingForm />
        </div>
      )}
    </div>
  )
}

export default PageHeader
